<template>
    <list-item-styled class="list-item" :isArticle="isArticle" :isSchool="isSchool" :isMessage="isMessage">
        <slot name="notice-type" />

        <div class="item-title">
            <div class="item-title__icon" @click="goSchool">
                <slot name="title-icon" v-bind="{ isRead }" />
            </div>
            <div>
                <div class="item-title__text" @click="goSchool">{{ title }}</div>
                <div class="item-title__date">{{ received_at }}</div>
            </div>
        </div>

        <div class="item-content">
            <slot name="content">
                <div class="item-content__html" v-html="content" />
            </slot>
        </div>

        <div v-if="image.length !== 0" class="item-images">
            <img
                v-for="(item, index) in image"
                :key="index"
                :src="item.imageThumbUrl ? item.imageThumbUrl : require('@/assets/ic_empty_image.png')"
                alt="첨부이미지"
                title="첨부이미지"
                @click="imageModalHandler(id, index)"
            />
        </div>

        <div v-if="file.length !== 0" class="item-files">
            <div class="item-files-title"><awesome-icon name="link" /> <span>첨부파일</span></div>
            <a
                v-for="(item, index) in file"
                :key="index"
                class="item-files__file"
                :href="item.fileUrl"
                target="_blank"
                :title="item.fileName"
            >
                <text-overflow>
                    {{ item.fileName }}
                </text-overflow>
            </a>
        </div>

        <div v-if="etc !== null" class="item-button">
            <st-button
                color="primary"
                :width="32.5"
                link
                :path="etc.replyUrl && etc.replyUrl"
                :disabled="!etc.replyUrl"
                target="_blank"
            >
                {{ etc.label }}
            </st-button>
        </div>

        <slot name="footer" />
    </list-item-styled>
</template>

<script>
import styled, { css } from "vue-styled-components";

import TextOverflow from "../components/TextOverflow";

const props = {
    isArticle: Boolean,
    isSchool: Boolean,
    isMessage: Boolean
};

const ListItemStyled = styled("div", props)`
    background-color: #ffffff;
    border-radius: 8px;
    box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.07);
    word-break: break-all;
    padding-bottom: 1.8rem;

    & + & {
        margin-top: 1.8rem;
    }

    .item-title {
        display: flex;
        align-items: center;
        padding: 2.4rem 2.4rem 1.8rem;

        &__text,
        &__icon {
            cursor: ${props => (props.isSchool ? "auto" : "pointer")};
        }

        &__icon {
            margin-right: 1rem;
        }

        &__text {
            font-size: 1.7rem;
            font-weight: bold;
        }

        &__date {
            margin-top: 4px;
            font-size: 1.4rem;
            color: ${props => props.theme.color.disabled};
        }
    }

    .item-content {
        ${props =>
            !props.isArticle &&
            !props.isMessage &&
            css`
                cursor: pointer;
            `}

        line-height: 1.6;
        padding: 0 2.4rem 1.8rem;
    }

    .item-button {
        width: 100%;
        text-align: center;
        padding: 0 2.4rem;
    }

    .item-images {
        padding: 0 2.4rem 1.8rem;
        display: flex;
        align-items: center;
        justify-content: flex-start;

        img {
            cursor: pointer;
            position: relative;
            width: 20%;
            padding: 10px;
            font-size: 0;
        }
    }

    .item-files {
        margin-bottom: 1.4rem;
        padding: 0 2.4rem 1.8rem;
        background-color: #f9fafc;

        &-title {
            padding: 1.8rem 0 1rem 0;
        }

        &__file {
            padding-left: 2.4rem;
            height: 2.4rem;
            line-height: 2.4rem;
            display: block;
            cursor: pointer;
            text-decoration: none;
            color: ${props => props.theme.color.black};

            &:hover * {
                text-decoration: underline;
            }

            svg {
                margin-right: 0.8rem;
            }
        }
    }
`;

export default {
    name: "ListItem",
    props: {
        ...props,
        id: String,
        isRead: Boolean,
        schoolId: String,
        boardIdx: String,
        title: String,
        content: String,
        etc: {
            type: Object,
            default: () => null
        }, // { label: String, type: String, isResponded: Boolean, replyUrl: String }
        image: Array,
        file: Array,
        received_at: String
    },
    methods: {
        imageModalHandler(id, index) {
            // index = message index
            this.$emit("image-view", { id, index });
        },

        goSchool() {
            // 학교 상세보기에서는 이동 못함 || 메시지도 마찬가지
            if (!this.boardIdx || this.$route.name.toLowerCase() === "school") return;
            this.$router.push(`/school/${this.schoolId}`);
        }
    },
    components: {
        ListItemStyled,
        TextOverflow
    }
};
</script>
